import { AthleteHeroBackground } from "@/components/athlete/AthleteHeroBackground";
import { useThemeCustomization } from "@/hooks/useThemeCustomization";
import type { AthleteBackgroundKey } from "@/lib/athleteTheme";

interface AthleteBrandHeaderProps {
  title?: string;
  subtitle?: string;
  backgroundKey?: AthleteBackgroundKey;
}

export function AthleteBrandHeader({ title, subtitle, backgroundKey }: AthleteBrandHeaderProps) {
  const { logoUrl, brandName, athleteBackgrounds } = useThemeCustomization();
  const backgroundUrl = backgroundKey ? athleteBackgrounds[backgroundKey] : undefined;

  return (
    <header className={`athlete-brand-header ${backgroundUrl ? "athlete-brand-header--image" : ""}`}>
      <AthleteHeroBackground src={backgroundUrl} />
      {backgroundUrl && <div className="athlete-brand-header-overlay absolute inset-0" />}
      <div className="relative z-10">
        <img src={logoUrl} alt={brandName} className="athlete-brand-logo" />
        {title && <h1 className="mt-5 text-3xl font-bold md:text-4xl">{title}</h1>}
        {subtitle && <p className="mt-1 max-w-xl text-sm text-muted-foreground md:text-base">{subtitle}</p>}
      </div>
    </header>
  );
}